var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPFman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.959 318.959",
    style: {
      enableBackground: "new 0 0 318.959 318.959"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F26D49"
    },
    d: "M303.671,253.512c-11.151-37.754-67.121-33.566-91.279-44.408 c-24.157-10.842-20.386-47.219-23.449-53.548H130.01c-3.058,6.329,0.714,42.711-23.449,53.548 c-24.157,10.842-80.133,6.655-91.279,44.408c-6.149,20.824-5.857,27.193-7.554,50.26c0,0,76.8,15.187,150.014,15.187 s153.488-15.187,153.488-15.187C309.527,280.699,309.82,274.337,303.671,253.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB5F24"
    },
    d: "M303.671,253.512c-11.151-37.754-67.121-33.566-91.279-44.408 c-24.157-10.842-20.386-47.219-23.449-53.548h-31.206c0,0-0.719,51.024,23.438,61.866s80.133,6.655,91.279,44.408 c5.857,19.83,5.868,26.552,7.324,47.073c19.234-2.816,31.442-5.126,31.442-5.126C309.527,280.699,309.82,274.337,303.671,253.512z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB491"
    },
    d: "M146.795,205.512l-1.225,26.057c4.221,1.647,8.807,2.911,13.849,3.625 c5.182-0.736,9.875-2.063,14.186-3.788l-2.484-25.889h-24.326V205.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C69E7F"
    },
    d: "M159.418,211.285c4.311-0.613,8.279-1.636,11.972-2.956l-0.27-2.816h-24.326l-0.118,2.563 C150.589,209.52,154.814,210.633,159.418,211.285z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EB5F24"
    },
    points: "209.155,207.401 176.105,236.116 171.12,205.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EB5F24"
    },
    points: "109.232,207.738 142.814,236.116 146.795,205.512  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DBD3"
    },
    d: "M146.795,205.512l-25.72-13.984c0,0-3.389,4.817-11.843,16.21l31.723,22.853l2.704-14.923 L146.795,205.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0DBD3"
    },
    d: "M171.12,205.512l25.72-13.984c0,0,3.861,4.48,12.315,15.873l-32.195,23.191l-2.704-14.923 L171.12,205.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3CEC7"
    },
    d: "M196.84,191.528l-25.72,13.984l1.776,5.772c2.372,2.602,5.109,4.716,8.279,6.138 c2.799,1.253,6.02,2.31,9.555,3.249l18.419-13.265C200.702,196.008,196.84,191.528,196.84,191.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB5F24"
    },
    d: "M60.619,312.062c27.631,3.552,62.771,6.897,97.124,6.897c35.112,0,71.854-3.496,100.581-7.133 v-22.853c0,0-56.852,8.526-100.721,8.526s-96.978-8.526-96.978-8.526v23.089H60.619z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.177 0.9842 -0.9842 -0.177 385.6469 -85.3759)",
    style: {
      fill: "#CCA483"
    },
    cx: 228.519,
    cy: 118.551,
    rx: 21.386,
    ry: 11.629
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9842 0.177 -0.177 -0.9842 200.0847 219.268)",
    style: {
      fill: "#DBB491"
    },
    cx: 90.262,
    cy: 118.558,
    rx: 11.629,
    ry: 21.386
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBB491"
    },
    d: "M223.64,47.359h-64.221H95.231c0,0-35.989,146.614,64.187,160.806 C259.633,193.973,223.64,47.359,223.64,47.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCA483"
    },
    d: "M159.418,208.165c100.216-14.192,64.221-160.806,64.221-160.806h-15.024 c4.114,61.242,9.808,93.774-13.815,129.24C176.083,204.703,159.418,208.165,159.418,208.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCA483"
    },
    d: "M211.561,43.498L86.839,53.817v30.447c0,0,3.417,2.366,6.216,3.232c0,0,34.19,7.655,57.735-1.343 c21.049-8.043,30.346-32.611,51.361-32.931c3.58-0.056,6.694,0.669,9.403,1.956L211.561,43.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B3B3B"
    },
    d: "M235.786,48.725C230.064,25.956,201.191,0,159.48,0S88.897,25.956,83.169,48.725 c0,0-10.932,47.483,7.683,67.931c0,0-0.916-18.548,0.956-33.313c0,0,34.19,7.655,57.735-1.343 c21.049-8.043,30.346-32.611,51.361-32.931c19.487-0.292,25.282,22.387,26.237,34.275s0.955,33.313,0.955,33.313 C246.717,96.208,235.786,48.725,235.786,48.725z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPFman);
export default __webpack_public_path__ + "static/media/PF man.c11b69e334c823ad25054ea7b13a1253.svg";
export { ForwardRef as ReactComponent };